var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppModal", {
    staticClass: "delete-modal",
    attrs: {
      id: "delete-product-modal",
      action: "Delete Product",
      title: "Are you sure?",
      "secondary-action": "Cancel",
      subheading: _vm.subheading,
      actionColor: "danger",
      secondaryActionColor: "black",
      hideClose: ""
    },
    on: {
      close: _vm.closeModal,
      "secondary-cta": _vm.closeModal,
      cta: _vm.deleteProduct
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }